export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Result"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Status"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Useful Links"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In Progress"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Failed"])}
}